class Authorization {
    constructor($rootScope, $state, principalService) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.principalService = principalService;
    }

    authorize() {
        return this.principalService.identity().then(() => {
            let isAuthenticated = this.principalService.isAuthenticated();

            if (this.$rootScope.toState.data.roles && this.$rootScope.toState.data.roles.length > 0 && !this.principalService.isInAnyRole(this.$rootScope.toState.data.roles)) {
                if (isAuthenticated) {
                    this.$state.go('app.accessdenied');
                } else {
                    this.$rootScope.returnToState = this.$rootScope.toState;
                    this.$rootScope.returnToStateParams = this.$rootScope.toStateParams;
                    this.$state.go('login');
                }
            }
        });
    }
}

Authorization.$inject = ['$rootScope', '$state', 'principalService'];

module.exports = Authorization;



// WEBPACK FOOTER //
// ./src/azurebackup/services/authorization.service.js